'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:HolydaysCtrl
 * @description
 * # HolydaysCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('HolydaysCtrl', ['$scope', 'Holyday', 'toaster', 'Pagination', function ($scope, Holyday, toaster, Pagination) {

      const SEARCH_ATTRIBUTES = {
        'search': '',
        'by_column': '',
        'filters': {
          'id': 'fa-sort-desc',
          'date': 'fa-sort-desc',
        }
      };
      $scope.search = SEARCH_ATTRIBUTES;

      $scope.holydays = {
        list: [],
        pager: {}
      };

      $scope.getPage = function(page) {
        var params = {
          params: {
            page: page,
            per_page: 10,
            search: $scope.search.search,
            by_column: $scope.search.by_column
          }
        };

        Holyday.index(params).then(function(response) {
          $scope.holydays = response.data.holydays
          $scope.holydays.pager = Pagination.GetPager(
            response.data.meta.pagination.total_objects,
            page,
            response.data.meta.pagination.per_page);
        }).catch(error => {
          console.error(error);
        });
      }

      $scope.clearSearch = function() {
        $scope.search = SEARCH_ATTRIBUTES;
        $scope.search.search = '';
        $scope.getPage(1);
      }

      $scope.pager = {};
      $scope.getPage(1);

      $scope.filter = function(column) {
        var order = '';
        angular.forEach($scope.search.filters, function(value, key) {
          if(column === key) {
            if($scope.search.filters[key] === 'fa-sort-desc') {
              $scope.search.filters[key] = 'fa-sort-asc';
              order = 'ASC';
            } else {
              $scope.search.filters[key] = 'fa-sort-desc';
              order = 'DESC';
            }
          } else {
            $scope.search.filters[key] = 'fa-sort';
          }
        });
        $scope.search.by_column = {
          column: column,
          order: order
        };
        $scope.getPage(1);
      };

      $scope.deleteHolyday = function(holyday) {
        var index = $scope.holydays.indexOf(holyday);
        Holyday.delete(holyday.id).then(function() {
          $scope.holydays.splice(index, 1);
          toaster.pop('success', 'Holyday', 'Se elimino correctamente el día festivo');
        }, function(error) {
          Holyday.error(error);
        });
      };

  }]);
